export * from './full-layout';
export * from './simple-layout';



// WEBPACK FOOTER //
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/containers/index.ts